"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CutAbilityHandler = exports.CutActorAbilityFactory = exports.CutAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
class CutAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Cut;
        this.__typeName = "Cut";
    }
}
exports.CutAbilityArgs = CutAbilityArgs;
let CutActorAbilityFactory = class CutActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Cut", "OneEnemies", 0);
    }
};
CutActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Cut")
], CutActorAbilityFactory);
exports.CutActorAbilityFactory = CutActorAbilityFactory;
let CutAbilityHandler = class CutAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 50)
            ]
        });
    }
};
CutAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Cut)
], CutAbilityHandler);
exports.CutAbilityHandler = CutAbilityHandler;
